// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"638":"a1e2a727","968":"f152242a"}[chunkId] + ".chunk.css";
};